let language = {
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MISSING-TITLE":"Coupon Code Invalid",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MISSING-CONTENT":"The coupon code you provided is invalid. Please check it and try again.",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MAX-TITLE":"Coupon quantity limit exceeded",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MAX-CONTENT":"You can only use one coupon. Please check the quantity and try again.",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-DUPLICATE-TITLE":"The coupon has already been used",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-DUPLICATE-CONTENT":"This coupon has already been used and cannot be reused. Sorry!",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-REMOVE-TITLE":"Remove the coupon code reminder",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-REMOVE-CONTENT":"Are you sure you want to remove this coupon code?",
};

export { language }

